import moment from 'moment'
import * as env from '../../config/env'

const calculateMinsDiff = (datetime1, datetime2) => {
    const d1 = moment(datetime1, env.DATETIME_CALCULATION_FORMAT)
    const d2 = moment(datetime2, env.DATETIME_CALCULATION_FORMAT)
    return d1.diff(d2, 'minutes')
}

export default calculateMinsDiff